import React, { FC, Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { Grid, Typography } from '@material-ui/core';

import { Queries } from 'components';
import { SegmentPicker } from 'components/Pickers';
import { ContentEmailValues } from 'features/admin/types';
import { UserSegmentFragment, SearchSortFieldsV2, UserStatus } from 'api';

import Tip from 'components/Tip';

const USER_SEARCH_VARIABLES = {
  user_status: UserStatus.Active,
  q: '',
  size: 1,
  sort: SearchSortFieldsV2.FullName,
};

const Recipients: FC = () => {
  const { t } = useTranslation();
  const { values, setFieldValue } = useFormikContext<ContentEmailValues>();
  const { all_users, segment_ids } = values;
  const [allSegments, setAllSegments] = useState<UserSegmentFragment[]>(null);

  function handleChange(segmentIds: Array<UserSegmentFragment['id']>) {
    setFieldValue('segment_ids', segmentIds);
    setFieldValue('all_users', false);
  }

  function handleEntireCompany() {
    setFieldValue('all_users', true);
    setFieldValue('segment_ids', []);
  }

  function renderNumRecipients() {
    if (segment_ids.length) {
      if (!allSegments) {
        return null;
      }
      const totalNumPeople = segment_ids.reduce((numPeople, segmentId) => {
        const segment = allSegments.find(currentSegment => currentSegment.id === segmentId);
        if (!segment) {
          return numPeople;
        }
        return numPeople + segment.registered_count + segment.third_party_count;
      }, 0);
      return <Fragment>({totalNumPeople})</Fragment>;
    }
    return (
      <Queries.GetUserSearchesV2 key="table" variables={USER_SEARCH_VARIABLES}>
        {(profiles, numActiveUsers, onLoadMore) => <Fragment>({numActiveUsers})</Fragment>}
      </Queries.GetUserSearchesV2>
    );
  }

  return (
    <Grid container>
      <Grid item xs={3}>
        <Typography variant="subtitle2">
          {t('common:recipient_plural')} {renderNumRecipients()}
        </Typography>
      </Grid>
      <Grid item xs={9}>
        <SegmentPicker
          isCompanySelected={all_users}
          selectedSegmentsIds={segment_ids}
          onSegmentChange={handleChange}
          onCompanySelected={handleEntireCompany}
          onLoadSegments={setAllSegments}
        />
        <Tip i18nKey="contentEmails:recipientsTip" />
      </Grid>
    </Grid>
  );
};

export default Recipients;
